// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"128":"5e451ca8","178":"eb88e0c6","356":"5e451ca8","654":"79332412"}[chunkId] + ".chunk.css";
};